import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as Config from "../config";
import Cookies from "js-cookie";
import moment from 'moment';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  actions: {
    // Inicio Peticiones de auth
    login({ commit }, form) {
      //commit("LOGIN");

      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/auth/inspector/login", form)
          .then(response => {
            if (response.data.code === 200) {
              const accessToken = response.data.data.access_token.token;
              const expires_in = moment().format("YYYY-MM-DD HH:mm");
              const expires_at = moment(expires_in).add(4, 'hours').format("YYYY-MM-DD HH:mm");
              const expires_at_date = new Date(expires_at);

              console.log(accessToken)
              /* onst username = response.data.data.full_name;
             const useremail = response.data.data.email;
             const profile = response.data.data.profile_picture;
             const id_role = response.data.data.role; */
              // const id_role = response.data.data.id_role;
              const is_inspector = response.data.data.is_inspector;
              const id = response.data.data.id;
              Cookies.set("access_token", accessToken, { expires: expires_at_date });

              /*  Cookies.set("user_name", username)
              Cookies.set("user_email", useremail)
              Cookies.set("picture", profile)
              Cookies.set("id_role", id_role) */
              Cookies.set("id", id)
              // Cookies.set("id_role", id_role, { expires: expires_at_date })
              Cookies.set("is_inspector", is_inspector, { expires: expires_at_date })
              //commit("LOGIN", response.data);
              resolve(response.data);
            } else {
              commit("LOGIN_FAIL1");
              reject(response.data);
            }
          })
          .catch(error => {
            console.log("LOGIN_FAIL");
            console.log(error);
            reject(error);
          });
      });
    },
    logout() {
      // Cookies.remove("access_token");
      // Cookies.remove("id");
      const cookies = Cookies.get();
      for (const cookie in cookies) {
        Cookies.remove(cookie);
      }
    },
    // logout() {
    //   Cookies.remove("access_token");
    //   Cookies.remove("id");
    // },

    // DEFINITIONS

    getData({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.get(Config.apiPath + "/" + form.url, { params: form.params }, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookies.get('access_token')}`

          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    createData({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form.data)
      return new Promise((resolve, reject) => {
        axios.post(Config.apiPath + "/" + form.url, form.data, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookies.get('access_token')}`

          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    updateData({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath + "/" + form.url + '/' + form.id, form.data, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookies.get('access_token')}`

          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    updateDataPayment({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath + "/" + form.url + '/' + form.id + '/' + form.approve, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookies.get('access_token')}`

          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    changeStatusData({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath + "/" + form.url + "/" + form.id + "/" + form.status, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookies.get('access_token')}`

          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    getFile({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.get(Config.apiPath + "/upload/all?active=1&type=" + form.type + "&page=" + form.page, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookies.get('access_token')}`

          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getFileMemeRequests({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.get(Config.apiPath + "/upload/meme/all", {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookies.get('access_token')}`

          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    UploadFile({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.post(Config.apiPath + "/upload/file", form, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookies.get('access_token')}`

          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    FileStatus({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath + "/upload/change_status/" + form.id + "/" + form.status, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookies.get('access_token')}`

          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    getVideo({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.get(Config.apiPath + "/upload/all?active=1", {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookies.get('access_token')}`

          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    UploadVideo({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.post('https://apibit.ticktaps.xyz/api/1.0/upload/file', form, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookies.get('access_token')}`

          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            resolve(error.response.data);
            reject(error.response.data);
          });
      });
    },
  },
  mutations: {

  }
})